import { useEffect } from "react";

export const PAGE_META = {
  pricing: {
    title: "Pricing — RideStamp | Plans for NEMT fleets of every size",
    description: "Plans sized by fleet with unlimited drivers: Starter $149/mo, Growth $299/mo, Fleet $599/mo, or custom Enterprise. 2-month free trial on every plan.",
  },
  contact: {
    title: "Contact RideStamp — Talk to our team",
    description: "Questions about RideStamp? Email hello@myridestamp.com, call (339) 234-4636, or send us a message and we'll reply within one business day.",
  },
  demo: {
    title: "Request a Demo — RideStamp",
    description: "See how RideStamp gives NEMT providers live dispatch, driver accountability and compliance tracking. Book a walkthrough tailored to your fleet.",
  },
};

const setDescription = (text) => {
  const el = document.querySelector('meta[name="description"]');
  if (el) el.setAttribute("content", text);
};

export function usePageMeta(key) {
  useEffect(() => {
    const prevTitle = document.title;
    const prevDesc = document.querySelector('meta[name="description"]')?.getAttribute("content");
    document.title = PAGE_META[key].title;
    setDescription(PAGE_META[key].description);
    return () => {
      document.title = prevTitle;
      if (prevDesc) setDescription(prevDesc);
    };
  }, [key]);
}
